export function productIndexValidate(product){
    var result = true;

    result = validateId(product.id);
    if(result == false) return result;

    result = validateSku(product.sku);
    if(result == false) return result;

    result = validateDescription(product.description);
    if(result == false) return result;

    result = validateUnit(product.unit);
    if(result == false) return result;

    result = validateStock(product.stock);
    if(result == false) return result;

    result = validateClient(product.client);

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateSku(sku){
    if(typeof sku === 'string' && sku.trim() !== '') return true;
    else return false;
}

function validateDescription(description){
    if(typeof description === 'string' || description.trim() !== '') return true;
    else return false;
}

function validateUnit(unit){

    if(typeof unit === 'string' || unit == undefined) return true;
    else return false;
}

function validateClient(client){
    if(typeof client.name !== 'string' || client.name.trim() === '') return false;
    if(typeof client.id !== 'number' || client.id.toString().trim() === '') return false;

    return true;
}

function validateStock(stock){
    return (typeof stock === 'object' && 
        typeof stock.id === 'number' &&
        typeof stock.quantity === 'number' &&
        typeof stock.reserved === 'number' &&
        typeof stock.damaged === 'number' &&
        typeof stock.available === 'number' 
    )
}